import { Component, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

@Component({
	selector: 'app-creative-carousel',
	styleUrls: ['./creative-carousel.component.css'],
	templateUrl: './creative-carousel.component.html'
})
export class CreativeCarouselComponent implements OnInit, WidgetCore, OnDestroy {
	public key: string;
	public showLoad = true;
	public placeholderimage: string;
	public reloadSubscription;
	public widgetDataSubscription;
	public creativePerformanceWidgetData;
	displayData: any;
	title: any;
	setSlideClassNames: any;

	constructor(private analyticsService: AnalyticsService) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
			this.creativePerformanceWidgetData = this.analyticsService.getCreativePerformanceData().subscribe((r: any) => {
				console.log(r);
			});
		});
	}

	ngOnInit(): void {
		this.requestData();
		if (this.key.toLowerCase().indexOf('display') !== -1) {
			this.title = 'Display';
			this.setSlideClassNames = {
				ClassName: 'img-src-Display',
				arrowClassName: 'arrowDisplay'
			};
		} else if (this.key.toLowerCase().indexOf('preroll') !== -1) {
			this.title = 'Pre Roll';
			this.setSlideClassNames = {
				ClassName: 'img-src-PreRoll',
				arrowClassName: 'arrowPreRoll'
			};
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success) {
				this.showLoad = true;
				this.setData(res.data);
			} else {
				this.showLoad = false;
				this.displayData = [];
			}
		});
	}

	processResponseData(responseData: any): void {
		this.displayData = responseData;
	}

	setData(response: any): void {
		this.displayData = response;
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.creativePerformanceWidgetData) {
			this.creativePerformanceWidgetData.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}
}
